import { useOfflineFirstQuery } from '../../hooks/useOfflineFirstQuery'
import { apiClient } from '../../api/client'

type ChildSession = {
  id: string
  session_date: string
  status: string
  provider_name: string
}

export default function ParentDashboardPage() {
  const { data, isFetching, error, refetch } = useOfflineFirstQuery<ChildSession[]>({
    queryKey: ['parent-sessions'],
    cacheKey: 'parent:sessions',
    staleTime: 1000 * 60,
    queryFn: async () => {
      const res = await apiClient.get('/api/v1/sessions/?scope=parent')
      return res.data?.results ?? res.data
    },
  })

  const rows = data ?? []

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-gray-900">My Child&apos;s Sessions</h1>
        <button
          onClick={() => refetch()}
          className="rounded-md border border-gray-200 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
        >
          Refresh
        </button>
      </div>

      {error && (
        <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
          {(error as Error).message}
        </div>
      )}

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Provider</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {isFetching && (
              <tr>
                <td colSpan={3} className="px-4 py-4 text-center text-sm text-gray-500">
                  Loading...
                </td>
              </tr>
            )}
            {rows.map((s) => (
              <tr key={s.id}>
                <td className="px-4 py-3 text-sm text-gray-700">{s.session_date}</td>
                <td className="px-4 py-3 text-sm text-gray-700">{s.provider_name}</td>
                <td className="px-4 py-3 text-sm text-gray-700">{s.status}</td>
              </tr>
            ))}
            {!isFetching && rows.length === 0 && (
              <tr>
                <td colSpan={3} className="px-4 py-4 text-center text-sm text-gray-500">
                  No sessions found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
